import PazienteDeviceList from "./components/PazienteDeviceList";
import PazienteDeviceEdit from "./components/PazienteDeviceEdit";
export default {
    PazienteDeviceList,
    PazienteDeviceEdit,
};
